import { i18next } from '@frontend/i18n';
import { SchemaCallIntelV2Service, SchemaTaskService } from './service';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'GetCallsOverview',
  'GetCallEditHistory',
  'OverviewStats',
  'DemoServiceQuality',
  'RecentCalls',
  'GetCallMetadata',
] as const satisfies (keyof typeof SchemaCallIntelV2Service)[];

export const STANDARD_QUERY_TASK_SERVICE_ENDPOINT_NAMES = [
  'ListTasks',
] as const satisfies (keyof typeof SchemaTaskService)[];

export const INFINITE_QUERY_ENDPOINT_NAMES = ['ListCalls'] as const satisfies (keyof Omit<
  typeof SchemaCallIntelV2Service,
  (typeof STANDARD_QUERY_ENDPOINT_NAMES)[number]
>)[];

export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const TASK_QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_TASK_SERVICE_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = [] as const satisfies (keyof Omit<
  typeof SchemaCallIntelV2Service,
  (typeof QUERY_ENDPOINT_NAMES)[number]
>)[];

export const timePeriodLabels: Record<string, string> = {
  'last-14-days': i18next.t('Last 14 Days', { ns: 'analytics' }),
  'last-30-days': i18next.t('Last 30 Days', { ns: 'analytics' }),
  'last-7-days': i18next.t('Last 7 Days', { ns: 'analytics' }),
  'last-month': i18next.t('Last Month', { ns: 'analytics' }),
  'last-quarter': i18next.t('Last Quarter', { ns: 'analytics' }),
  'last-week': i18next.t('Last Week', { ns: 'analytics' }),
  'this-month': i18next.t('This Month', { ns: 'analytics' }),
  'this-quarter': i18next.t('This Quarter', { ns: 'analytics' }),
  'this-week': i18next.t('This Week', { ns: 'analytics' }),
  today: i18next.t('Today', { ns: 'analytics' }),
  yesterday: i18next.t('Yesterday', { ns: 'analytics' }),
};

export const useTimePeriodFilterLabels = () => {
  return timePeriodLabels;
};

export const baseUrlV2 = 'call-intelligence/v2';
